import { type IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { createSlice } from '@reduxjs/toolkit';

import { ASYNC_STATUS, type AsyncStatus } from '@/packages/typesafe-result';

import { loadUndergroundMapManifest } from '../../thunks/undergroundMapManifest';

export interface IUndergroundMapState {
  status: AsyncStatus;
  manifest?: IMicrofrontendManifest;
}

const undergroundMapInitialState: IUndergroundMapState = {
  status: ASYNC_STATUS.IDLE,
};

export const undergroundMapSlice = createSlice({
  initialState: undergroundMapInitialState,
  name: 'undergroundMap',
  reducers: {
    reset(state) {
      state.status = ASYNC_STATUS.IDLE;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(loadUndergroundMapManifest.pending, state => {
        state.status = ASYNC_STATUS.PENDING;
      })
      .addCase(loadUndergroundMapManifest.fulfilled, (state, action) => {
        state.status = ASYNC_STATUS.SUCCESS;
        state.manifest = action.payload.manifest;
      })
      .addCase(loadUndergroundMapManifest.rejected, state => {
        state.status = ASYNC_STATUS.ERROR;
      });
  },
});

export const { reducer: undergroundMapReducer, actions: undergroundMapActions } = undergroundMapSlice;
